/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'book': {
    viewBox: '0 0 32 32',
    data: '<path class="st0" style="fill:#010101;" d="M7,1C4.8,1,3,2.8,3,5v22c0,2.2,1.8,4,4,4h22v-6v-2V1H7z M7,3h1v20H7c-0.7,0-1.4,0.2-2,0.6V5C5,3.9,5.9,3,7,3z M27,29H7c-1.1,0-2-0.9-2-2s0.9-2,2-2h1h19V29z M10,23V3h9v1v12l3-3l3,3V3h2v20H10z"/>'
  }
})
